import { createFileRoute } from '@tanstack/react-router'
import { Inspections } from 'pages/assetDatabase/assetOverview/Inspections'

export const Route = createFileRoute('/inspections/$siteID')({
  component: Inspections,
})
